import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';


export default function Userloantopup()
{
    const navigate = useNavigate();
    const date = new Date().toISOString().slice(0,10);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [user, setUser] = useState([]);
    const APP_NAME = process.env.REACT_APP_NAME;
    
    

    useEffect(() =>
    {
        fetch(API_URL+"api/Userloan/GetUserLoan")
        .then(response => response.json()).then(data => {setUser(data)});

        

    },[])

    console.log(user);


    function loaduser()
    {
        var userid = parseInt(document.getElementById('userid').value);
        console.log(userid);

        var finduser = user.filter((e) => {if(e.Userid === userid) return e});

        console.log(finduser);

        if(finduser.length > 0)
        {
            document.getElementById('edate').value = finduser[0].EntryDate.slice(0,10);
            document.getElementById('fdate').value = finduser[0].ForDate.slice(0,10);
            document.getElementById('topupamount').value =finduser[0].LoanAmount;
            
        }
        else if (document.getElementById('userid').value !== '')
        {
            noloandialog();
            document.getElementById('userid').value = '';
            document.getElementById('edate').value = '';
            document.getElementById('fdate').value =  '';
            document.getElementById('topupamount').value ='';
        }
        else
        {

        }
    }

    function topuploan()
    {
        fetch(API_URL+"api/Userloan/TopupUserLoan?topup="+document.getElementById('topupamount').value+"&userid="+document.getElementById('userid').value,{method:"PUT",body:null})
        .then(response => response.json()).then(data => {setUser(data)});
        showOKdialog();
    }
    
    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
        dialog.showModal();
    }

    function noloandialog()
    {
    const dialog = document.getElementById('noloanDialog');
    dialog.showModal();
    }

    function closenoloandialog()
    {
    const dialog = document.getElementById('noloanDialog');
    dialog.close();
    }

    return(
        <>
        <div className="reportheader"> {APP_NAME}
            
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1,marginBottom:"20px"}}>Balance Add-On</div>
        
        <div>
            
            <label for ="userid" style ={{marginLeft:"10%"}}>User ID</label>
            <input id = "userid"  style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} onChange={()=>{loaduser()}}></input>
            <label for = "edate" style ={{marginLeft:"10%"}} >Entry Date</label>
            <input id = "edate" type="date"  value = {date} style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} readOnly></input><br/><br/>
            <label for = "fdate" style ={{marginLeft:"10%"}}>For Date</label>
            <input id = "fdate" type="date" defaultValue = {date} style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} ></input><br/><br/>
            <label for = "topupamount" style ={{marginLeft:"10%"}}>Topup Amount</label>
            <input id = "topupamount" style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} ></input>
            
        </div>
        
        <div style ={{marginTop:"70px"}}>
        <button type = "button"  className='actionbuttons' onClick={()=>{topuploan()}}>Add-On</button> 
        <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/user')}}>Cancel</button>
        </div>
        <dialog id = "myDialog" className="okdialog">
            <p>Balance Topup Successful</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/user')}}>OK</button>
        </dialog>

        <dialog id = "noloanDialog" className="okdialog">
            <p>No Opening Balance Found For Given User</p>
            <button className="okdialogbutton" onClick={()=>{closenoloandialog()}}>OK</button>
        </dialog>

        
        </>
    )
}